import axios from "axios";
import store from "@/store";
import storage from "store";
import notification from "ant-design-vue/es/notification";
import { ACCESS_TOKEN } from "@/store/mutation-types";
import { urlConfig } from "@/config/config";
import router from "../router";
import { message } from "ant-design-vue";

// 创建 axios 实例
const request = axios.create({
  baseURL: urlConfig.baseUrl,
  timeout: 100000, // 请求超时时间
});

// 异常拦截处理器
const errorHandler = (error) => {
  if (error.response) {
    const data = error.response.data;
    // 从 localstorage 获取 token
    const token = storage.get(ACCESS_TOKEN);
    if (error.response.status === 403) {
      notification.error({
        message: "Forbidden",
        description: data.message,
      });
    }
    if (
      error.response.status === 401 &&
      !(data.result && data.result.isLogin)
    ) {
      notification.error({
        message: "Unauthorized",
        description: "Authorization verification failed",
      });
      if (token) {
        store.dispatch("Logout").then(() => {
          setTimeout(() => {
            window.location.reload();
          }, 1500);
          localStorage.removeItem("userMsg");
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("roles");

          localStorage.removeItem("path", "");
          localStorage.removeItem("SET_SYSTEM");
          this.$store.commit("SET_CURRENT", "");
          this.$store.commit("SET_SYSTEM", "");
        });
      }
    }
  }
  return Promise.reject(error);
};

// request interceptor
request.interceptors.request.use((config) => {
  let token = sessionStorage.getItem("token");
  let tenantId = sessionStorage.getItem("tenant_id");
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  if (token) {
    config.headers["token"] = token;
    config.headers["tenant-id"] = tenantId;
    config.headers["Cache-Control"] = "no-cache";
  }
  return config;
}, errorHandler);

// response interceptor
request.interceptors.response.use((response) => {
  if (response.data.code == "500" && response.data.msg == "Token Expiration") {
    sessionStorage.removeItem("token");
    // 跳转到登录
    router.push({ path: "/login" });
    return;
  } else if (
    response.data.code == "401" &&
    response.data.msg == "No Permission"
  ) {
    // 无权访问
    message.error("无权访问");
  }
  return response.data;
}, errorHandler);

// Vue 插件安装方法
request.install = function(Vue) {
  // 挂载到 Vue 原型，组件中可通过 this.$http 或 this.$axios 访问
  Vue.prototype.$http = this;
  Vue.prototype.$axios = this;
};

export default request;
